import { ScopeVersion } from '@app/core/model/scope-version'
import { plainToInstance } from 'class-transformer'
import { mapScopeSection } from './map-scope-entity.utils'
import { mapScopeFee } from './map-scope-fee.utils'

export const mapScopeVersion = (scope: ScopeVersion): ScopeVersion => {
  return plainToInstance(ScopeVersion, {
    ...scope,
    deliverables: [],
    sections: (scope?.sections || []).map((section) => mapScopeSection(section)),
    feeItems: (scope?.feeItems || []).map((feeItem) => mapScopeFee(feeItem)),
  })
}
